import React, { Fragment } from 'react';
import { Grid, Stack, Typography, Box, Popover, Tooltip, Radio, RadioGroup, Divider, Checkbox, InputAdornment, IconButton } from '@mui/material';
import { CustomButton, CustomRadio, CustomTextField, DataGridProps, InputProps, NUMBERINPUT_PROPS, StyledCard, StyledCardTitle, StyledDataGrid, TableBadge, CustomCheckbox, FlexDiv } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import reportStyles from './reports.module.css';
import flightStyles from '../../flightsfolder.module.css';
import PDF from '../../../../../assets/images/pdf.svg';
import theme from 'custom/theme';
import { AddIcon, DateFormat, DeleteIcon, ExcelIcon, StickyNoteIcon, contractType, statisticsRoles } from 'custom/constants';
import ManifestSummaryContainer from '../../summary/ManifestSummaryContainer';
import cookies from 'utils/cookies';
import AddReportDocModal from './AddReportDocModal';
import { dateTolocale } from 'utils/converter';
import difference from 'lodash/difference';
import AddNotes from './AddNotes';
import { JsonToExcel } from 'custom/export';
import ReviewModal from 'components/pages/common/ReviewModal';
import ReOpenModal from 'components/pages/common/ReOpenModal';
import moment from 'moment';
import StatusModal from 'components/pages/common/StatusModal';
import FlightReportPDFDownloadContainer from 'components/pages/flightReportPDFDownload/FlightReportPDFDownloadContainer';
import DocViewer from './DocViewer';
import { Close } from '@mui/icons-material';

const timezone = cookies.get('timezone') || null;

const checkAccessArray = (rowrole, userrole) => {
  let flag = false;
  let foundroles = statisticsRoles.find((statRole) => statRole.role === rowrole);
  if (foundroles?.access.includes(userrole)) {
    flag = true;
  }
  return flag;
};

const FlightReport = (props) => {
  const filename = `${props.flight?.airline?.code}${props.flight?.flight_no}/${moment(props.flight?.flight_date).format('DDMMMYY').toUpperCase()}`;

  const checklistColumns = [
    //Checkbox column is added only when showReportModal is true due to multiple selection issue in billing flight report modal
    ...props.showReportModal ? [{
      field: 'select',
      headerName: '',
      width: 50,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <Checkbox size='small' className={styles.p0}
            disabled
            checked={props.rowSelectionModel.includes(row?.id)}
          />
        );
      }
    }] : [],
    {
      field: 'description',
      headerName: 'Checks',
      minWidth: 150,
      flex: 1,
      cellClassName: styles.cellTextWrap
    },
    {
      field: 'role',
      headerName: 'Roles',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'user',
      headerName: 'Entered By',
      minWidth: 100,
      flex: 1,
      className: reportStyles.checkdetailsText,
      renderCell: ({ row }) => {
        let length = row?.flight_checklist?.length - 1;
        let checklist_data = row?.flight_checklist[length];
        let user = checklist_data?.user;
        let userDetails = `${user?.first_name} ${user?.last_name} | ${dateTolocale(checklist_data?.created, DateFormat + ' ' + 'HH:mm')?.toUpperCase()}`;
        return user ? <div className={reportStyles.checkdetails}>{userDetails} </div> : '';
      }
    },
    {
      field: 'remark',
      headerName: 'Remarks',
      align: 'center',
      headerAlign: 'center',
      minWidth: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        let arrayLength = row?.flight_checklist && row?.flight_checklist?.length > 0 && row?.flight_checklist?.length - 1;
        let lastArrayId = row?.flight_checklist && row?.flight_checklist?.length > 0 && row?.flight_checklist[arrayLength]?.id;
        return (<div className={reportStyles.addTextFieldStats}>
          <CustomTextField
            {...InputProps}
            label={false}
            variant='outlined'
            id='remarks'
            fullWidth
            placeholder=''
            type='text'
            name=''
            disabled={(getReportstatus() === 'Submitted' || getReportstatus() === 'Finalized') ? props.disabledChecklistRemarks(row) : true}
            onChange={(e) => props.handleChecklistRemarks(e, row, 'add')}
            onFocus={() => props.setChecklistId(row)}
            onBlur={props.saveRemark}
            value={props.checklistRemarks[lastArrayId]?.remark || ''}
            onKeyDown={(event) => {
              event.stopPropagation();
            }}
            sx={{
              marginTop: '-4px',
              marginBottom: '-4px'
            }}
            className={styles.borderedIpTextfield}
            InputProps={{
              classes: {
                root: styles.borderedIpRoot,
                input: styles.borderedIp,
                notchedOutline: styles.notchedOutline,
                error: styles.errorInput,
              },
            }}
          />
        </div>);
      }
    }
  ];

  const statColumn = [
    {
      field: 'description',
      headerName: 'Line Item',
      minWidth: 100,
      flex: 1,
      cellClassName: styles.cellTextWrap
    },
    {
      field: 'applied_on',
      headerName: 'Driver',
      minWidth: 100,
      flex: 1,
      cellClassName: styles.cellTextWrap,
      renderCell: ({ row }) => {
        let applied_on = row.applied_on;
        return applied_on && applied_on.includes('Auto') ? applied_on.split('|')[0] : applied_on;
      }
    },
    {
      field: 'roles',
      headerName: 'Roles',
      minWidth: 100,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => {
        return (
          <div className={`${reportStyles.checkdetails} ${styles.textCenter}`}>
            {row.roles && row.roles.length > 0 ? row.roles[0] : '-'}
          </div>
        );
      }
    },
    {
      field: 'user',
      headerName: 'Entered By',
      minWidth: 100,
      flex: 1,
      className: reportStyles.checkdetailsText,
      renderCell: ({ row }) => {
        if (!row?.user) {
          if (row.applied_on.includes('Auto')) {
            return <div className={`${reportStyles.centerAlignText}`}>Auto</div>;
          } else {
            return <div className={`${reportStyles.centerAlignText}`}> - </div>;
          }
        } else {
          return (
            <div className={reportStyles.checkdetails}>
              {`${row?.user?.first_name || ''} ${row?.user?.last_name || '-'} | ${row?.date ? moment(row.date).tz(timezone).format('DDMMMYY HH:mm')?.toUpperCase() : '-'}`}
            </div>
          );
        }
      }
    },
    {
      field: 'remark',
      headerName: 'Quantity',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center' 
          }}>
            <CustomTextField
              {...InputProps}
              sx={NUMBERINPUT_PROPS}
              label={false}
              variant='outlined'
              id='loose_kgs'
              fullWidth
              placeholder=''
              type='number'
              name='quantity'
              disabled={
                props.isNoOp ? true :
                  row?.loadingaccessoriesId ? true :
                    getReportstatus() !== 'Submitted' ? true
                      : row.applied_on.includes('Auto') && (cookies.get('role') !== 'Senior Accounting' && cookies.get('role') !== 'System Admin' && cookies.get('role') !== 'Manager')
                        ? true
                        : row.applied_on.includes('Manual') && row.roles && row.roles.length > 0 &&
                    !checkAccessArray(row.roles?.[0], cookies.get('role'))
              }
              value={
                props?.focusedRowIndex === row?.rowIndex
                  ? row.quantity
                  : (() => {
                    let baseValue = row.quantity && !isNaN(parseFloat(row.quantity)) ? 
                      (row.applied_on.includes('KG') ? Math.round(parseFloat(row.quantity) * 100) / 100 : parseFloat(row.quantity)) : 
                      row.applied_on.includes('Auto') || row?.loadingaccessoriesId ? 0 : '';
                    
                    if (props.exclude_disc === false && !isNaN(parseFloat(row.dis_quantity))) {
                      let finalval = (parseFloat(baseValue) || 0) + parseFloat(row.dis_quantity);
                      if( baseValue === '' && row.dis_quantity === 0) {
                        finalval = '';
                      }
                      finalval = Math.round(finalval * 100) / 100;
                      if (row.applied_on && row.applied_on.includes('Manual') && !row?.user && !row?.loadingaccessoriesId) {
                        finalval = '';
                      }
                      return finalval;
                    }
                    baseValue = Math.round(baseValue * 100) / 100;
                    if (row.applied_on && row.applied_on.includes('Manual') && !row?.user && !row?.loadingaccessoriesId) {
                      baseValue = '';
                    }
                    return baseValue;
                  })()
              }
              onChange={(e) => props.handleStats(e, props.contindex, row.rowIndex)}
              onBlur={props.handleStatisticPost}
              onFocus={() => props.setFocusedRowIndex(row.rowIndex)}
              className={`${styles.borderedIpTextfield} ${reportStyles.statIpTextfield}`}
              InputProps={{
                classes: {
                  root: `${styles.borderedIpRoot} ${reportStyles.statIpRoot}`,
                  input: `${styles.borderedIp} ${reportStyles.statIp}`,
                  notchedOutline: styles.notchedOutline,
                  error: styles.errorInput,
                },
                endAdornment: (
                  <InputAdornment position='end' >
                    {(row?.manual || row.applied_on.includes('Manual'))&& (
                      !(props.isNoOp ? true :
                        row?.loadingaccessoriesId ? true :
                          getReportstatus() !== 'Submitted' ? true
                            : row.applied_on.includes('Auto') && (cookies.get('role') !== 'Senior Accounting' && cookies.get('role') !== 'System Admin' && cookies.get('role') !== 'Manager')
                              ? true
                              : row.applied_on.includes('Manual') && row.roles && row.roles.length > 0 &&
                          !checkAccessArray(row.roles?.[0], cookies.get('role')))
                    ) &&
                    <IconButton title='Clear' color='primary' className={styles.p0} disableRipple sx={{ marginRight: '-8px' }}
                      disabled={props.isNoOp ? true : false}
                      onClick={() => {
                        // Simulate an event for clearing
                        const event = { target: { value: '' } };
                        props.clearStats(event, props.contindex, row.rowIndex);
                      }}>
                      <Close sx={{ fontSize: 13 }} />
                    </IconButton>
                    }
                  </InputAdornment>
                )
              }}
            />
          </div>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      minWidth: 40,
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      className: styles.flexWrap,
      renderCell: ({ row }) => {
        return (
          <TableBadge badgeContent={row?.note?.length} color='error' overlap='circular'>
            <StickyNoteIcon title='Add/View Notes' onClick={(e) => props.openPopup('notes', e.currentTarget, props.contindex, row.rowIndex, row)} />
          </TableBadge>
        );
      }
    }
  ];

  const getReportstatus = () => {
    let status = null;
    let logs = props.reportLogs.find((log) => log.type === props?.cont_item);
    if (logs && logs.log && logs.log.length > 0) {
      let lastlog = logs.log[logs.log.length - 1];
      status = (((logs.status !== 'Submitted' || logs.status === 'Submitted') && logs.status !== 'Finalized' && logs.status !== 'Pending' && (!logs.approved_acc && !logs.approved_air)) && !lastlog.rejected) ? 'Submitted' :
        (!logs.approved_acc || !logs.approved_air) ? 'Approved' : null;
    } else {
      status = 'Submitted';
    }
    return status;
  };

  const handleCheck = () => {
    const data = props.filteredData?.map((row) => {
      return {
        Checks: row.description,
        Roles: row.role,
        Performed_By: row?.flight_checklist?.length > 0 ? `${row?.flight_checklist[row?.flight_checklist.length - 1]?.user?.first_name} ${row?.flight_checklist[row?.flight_checklist.length - 1]?.user?.last_name}` : '',
        Performed_Time: row?.flight_checklist?.length > 0 ? dateTolocale(row?.flight_checklist[row?.flight_checklist.length - 1]?.created, DateFormat + ' ' + 'HH:mm') : '',
        Remarks: row?.flight_checklist?.length > 0 ? row?.flight_checklist[row?.flight_checklist.length - 1]?.remark : '',
      };
    });
    JsonToExcel(data, `Flight Report Checklist - ${filename}`);
  };

  const handleStat = () => {
    const data = props.statRows?.map((row) => {
      return {
        LineItem: row.description,
        Driver: row.applied_on,
        Roles: row.roles && row.roles.length > 0 ? row.roles[0] : '-',
        Entered_By: row?.applied_on.includes('Auto') ? 'Auto' : `${row?.user?.first_name || ''} ${row?.user?.last_name || ''}`,
        Entered_Time: row?.date ? dateTolocale(row.date, DateFormat + ' ' + 'HH:mm') : '',
        Remarks: row.quantity,
      };
    });
    JsonToExcel(data, `Statistics- ${filename}`);
  };

  return (
    <>
      <Grid container columnSpacing={3} rowSpacing={3} className={reportStyles.gridContainer} sx={{ marginTop : props.showRejectedMessage || props.showNilMessage ? '10px' : '-24px' }}>
        <Grid item xs={12} container columnSpacing={3} rowSpacing={3} justifyContent={'space-between'} position={'relative'}>
          {
            !props.ctype ?
              <Grid item xs={3}>
                <RadioGroup
                  aria-labelledby='contract-type-radio-buttons-group'
                  name='contract-type-radio-buttons-group'
                  value={props.cont_item}
                  row
                  className={styles.radioToggleGroup}
                >
                  {Object.entries(contractType).map(([, value], index) => {
                    if (props.userContractTypes?.includes(value)) {
                      return <Fragment key={index}>
                        <CustomRadio
                          value={value}
                          control={<Radio className={styles.radioToggleBtn} onChange={() => props.handleStatType(index, value)} />}
                          label={value}
                          className={`${styles.radioToggle} ${props.cont_item === value ? styles.radioToggleBtnChecked : ''
                          }`}
                          classes={{ label: styles.radioToggleLabel }}
                        />
                      </Fragment>;
                    }
                  })
                  }
                </RadioGroup>
              </Grid>
              : null
          }

          <Grid item xs={12}
            className={styles.pt0}
            sx={{
              position: 'relative',
              [`& .${flightStyles.manifestCheckbox}`]: {
                maxWidth: 'max-content',
                marginLeft: 'auto',
                marginRight: '60px !important',
              },
              [`& .${flightStyles.manifestCard}`]: { marginBottom: '0px !important', },
              [`& .${flightStyles.summaryCollapse}`]: {
                marginTop: '-12px !important',
                transition: 'margin-top 0.3s ease-in-out',
              },
              [`& .${flightStyles.summaryShow}`]: {
                marginTop: '0px !important',
                transition: 'margin-top 0.3s ease-in-out',
              } 
              
            }}>
            <ManifestSummaryContainer 
              showReportModal={props.showReportModal} 
              nil={props.nil_manifest} 
              flightreportData={props.flightData}
              discrepancyList={props.discrepancyList}
              exclude_disc={props.exclude_disc} 
              printFunction={props.printFunction} 
            />
            <div className={`${reportStyles.excelWrapper} ${flightStyles.reportIcon} `}>
              <div className={`${styles.mr4}`}></div>
              <FlightReportPDFDownloadContainer 
                history_data={props.history_data} 
                nil={props.nil_manifest} 
                statistics={props.statRows} 
                checklist={props.filteredData} 
                ctype={props.ctype} 
                exclude_disc={props.exclude_disc}
                airlineLogo={props.airlineLogo}
                updatedisableFlightFields={props.updatedisableFlightFields}
                disableFlightFields={props.disableFlightFields}
              />
            </div>
          </Grid>
        </Grid>
        {
          props.userContractTypes && props.userContractTypes.length > 0 ?
            <Grid item xs={12} container columnSpacing={3} rowSpacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={5} className={reportStyles.gridItem} classes={{ root: reportStyles.gridItem }}>
                <StyledCard className={styles.h100}>
                  <FlexDiv><StyledCardTitle>Flight Report Checklist</StyledCardTitle></FlexDiv>
                  <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-26px'}>
                    <ExcelIcon title='Download File' onClick={handleCheck} className={styles.tableIcon} />
                  </Stack>
                  <div className={styles.tableWrapper}>
                    <Box className={`${styles.tableOuter} ${reportStyles.checklistTableOuter}`} sx={{ height: 500 }}>
                      <StyledDataGrid
                        {...DataGridProps}
                        rows={props.filteredData || []}
                        columns={checklistColumns}
                        checkboxSelection={props.showReportModal || props.isNoOp ? false : true}
                        isRowSelectable={(params) =>  props.isNoOp ? false : getReportstatus() === 'Submitted' ? props.isRowSelectable(params.row) : false}
                        disableRowSelectionOnClick={true}
                        rowSelectionModel={props.showReportModal ? [] : props.rowSelectionModel}
                        //multipleSelection gives error on billing flight report modal
                        onRowSelectionModelChange={(ids, d) => {
                          props.onRowsSelectionHandler(ids, d);
                          const selectedIds = difference(ids, props.rowSelectionModel);
                          const unselectedIds = difference(props.rowSelectionModel, ids);
                          props.checkboxSelectionHandler(selectedIds, unselectedIds);
                        }}
                        className={reportStyles.checklistTable}
                        classes={{ checkboxInput: styles.p0 }}
                        sx={{
                          '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': { display: 'none' },
                          '& .MuiDataGrid-row .MuiDataGrid-cell:not(:nth-last-of-type(2))': { paddingRight: 0 },
                        }}
                        getRowClassName={(params) => params.row.isRedCheckist && props.redChecklist ? reportStyles.redRow : ''}
                        param={props.filteredData?.length}
                      />
                    </Box>
                  </div>
                </StyledCard>
              </Grid>

              <Grid item xs={12} sm={6} md={8} lg={8} xl={5} className={reportStyles.gridItem}>
                <StyledCard className={`${styles.h100} ${styles.w100} ${styles.fColumn}`}>
                  <FlexDiv><StyledCardTitle>Statistics {props.nil ? ' (Nil Manifest)' : ''}</StyledCardTitle></FlexDiv>
                  <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-28px'}>
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': 'Friday', }} checked={props.exclude_disc} onChange={props.toggleDiscrepancy} name='exclude_disc' />
                      } label='Exclude Discrepancies' />
                    <ExcelIcon title='Download File' onClick={handleStat} className={styles.tableIcon} />
                  </Stack>
                  <div className={styles.tableWrapper}>
                    <Box className={`${styles.tableOuter} ${reportStyles.checklistTableOuter}`} sx={{ height: 500 }}>
                      <StyledDataGrid
                        {...DataGridProps}
                        rows={props.statRows || []}
                        columns={statColumn}
                        param={props.statRows?.length}
                        sx={{ '& .MuiDataGrid-row .MuiDataGrid-cell:not(:last-of-type)': { paddingRight: 0 } }}
                      />
                    </Box>
                  </div>
                </StyledCard>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4} xl={2} className={reportStyles.gridItem}>
                <StyledCard elevation={0} className={styles.h100}>
                  <FlexDiv><StyledCardTitle>Attachment</StyledCardTitle></FlexDiv>
                  <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-26px'}>
                    {<AddIcon title='Add Document' onClick={() => props.handleOpen('add_doc')} disabled={props.showReportModal} />}
                  </Stack>
                  <Stack spacing={3} className={reportStyles.attachmentWrapper}>
                    {props.attachment.map((item) => (
                      <div key={item.id}>
                        <div className={styles.positionRelative}>
                          <DeleteIcon onClick={(e) => { props.handleDelete(item.id, e.target); }} disabled={(props.ffmData?.msg_id? props.ffmData?.msg_id == item?.message_logId:props.ffmData?.ffmId == item?.id) || props.showReportModal} className={reportStyles.delIcon} />
                          <Tooltip title='View document'>
                            <div className={`${reportStyles.pdfWrapper} ${styles.mb3} ${styles.pointer}`} 
                              onClick={() => {
                                let name = item.src.split('/').pop();
                                if (item.src.includes('.pdf')) {
                                  name = props.flight?.airline?.code+props.flight?.flight_no + '_' + moment(props.flight?.flight_date).format('DDMMMYY')?.toUpperCase() + '.pdf';
                                }
                                props.handleOpen('attached_docs', {
                                  name: `${item.name + '_' + name}`,
                                  src: item.src, 
                                });
                              }}>
                              <img src={PDF} alt='pdf' width={'50px'} height={'60px'} />
                            </div>
                          </Tooltip>
                        </div>
                        <Stack spacing={1}>
                          <div className={`${styles.dFlex} ${styles.fWrap}`}>
                            <Typography variant='caption' component='div' lineHeight='normal' display={'inline-block'} className={reportStyles.attDetails}>Document Type </Typography>
                            <Typography variant='caption' component='span' lineHeight='normal' fontWeight={'bold'} color={theme.palette.primary.main} textAlign={'right'}>{item.name}</Typography>
                          </div>
                          <div className={styles.dFlex}>
                            <Typography variant='caption' component='div' lineHeight='normal' display={'inline-block'} className={reportStyles.attDetails}>Pages</Typography>
                            <Typography variant='caption' component='span' lineHeight='normal' fontWeight={'bold'} color={theme.palette.primary.main} textAlign={'right'}>{item.numPages}</Typography>
                          </div>
                          <div className={styles.dFlex}>
                            <Typography variant='caption' component='div' lineHeight='normal' display={'inline-block'} className={reportStyles.attDetails}>Added By</Typography>
                            <Typography variant='caption' component='span' lineHeight='normal' fontWeight={'bold'} color={theme.palette.primary.main} textAlign={'right'}>{item.added_by ? `${item.added_by?.first_name} ${item.added_by?.last_name}` : 'Docs Stream'}</Typography>
                          </div>
                          <div className={styles.dFlex}>
                            <Typography variant='caption' component='div' lineHeight='normal' display={'inline-block'} className={reportStyles.attDetails}>Date Added</Typography>
                            <Typography variant='caption' component='span' lineHeight='normal' fontWeight={'bold'} color={theme.palette.primary.main} textAlign={'right'}>{dateTolocale(item.created, DateFormat + ' ' + 'HHmm').toUpperCase()}</Typography>
                          </div>
                        </Stack>
                      </div>
                    ))}
                  </Stack>
                </StyledCard>
              </Grid>
            </Grid> : null
        }

        {!props.showReportModal &&
          props.userContractTypes && props.userContractTypes.length > 0 ?
          <Grid item container columnSpacing={3} rowSpacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} order={{
              xs: 2,
              xl: 1
            }}>
              <div ref={props.refROBrn} className={styles.w100}>
                <CustomButton variant='contained' className={`${styles.minWidth280}`} name='reopen'
                  onClick={() => { props.handleClick(props.refROBrn.current, 3); }}
                  disabled={ props.isNoOp || props.disableButtons('Reopen') ? true : false} > Reopen Flight Report (Supervisors Only)</CustomButton>
              </div>
            </Grid>
            <Grid item xs={12} xl={4} order={{
              xs: 1,
              xl: 2
            }}>
            </Grid>
            {
              props.statRows?.length > 0 ?
                <Grid item xs={12} sm={6} md={6} lg={6} xl={2} order={{ xs: 3 }}>
                  {
                    ( getReportstatus() === 'Submitted') ?
                      <div className={`${reportStyles.finalizeBtn} ${styles.mlauto}`}>
                        <CustomButton variant='contained' className={`${styles.mlauto} ${styles.dFlex} ${styles.w100}`} name='submit' onClick={() => props.handleChange('Submitted', null, null)}
                          disabled={ props.isNoOp || props.disableButtons('Submitted') ? true : false}
                        >	Submit for Billing</CustomButton>
                      </div>
                      :
                      cookies.get('isapprover') === 'true' ?
                        (cookies.get('role') === 'Accounting' || cookies.get('role') === 'Senior Accounting' || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'System Admin' || cookies.get('role') === 'Supervisor') ?
                          <div className={`${styles.dFlex} ${styles.gap10} ${styles.w100}`}>
                            <div ref={props.refBtn} className={styles.w100}>
                              <CustomButton variant='contained'
                                className={`${styles.mlauto} ${styles.dFlex} ${reportStyles.finalizeBtn}`}
                                name='approve'
                                onClick={() => { props.handleClick(props.refBtn.current, 2); }}
                                disabled={ props.isNoOp || props.disableButtons('Approved') ? true : false}
                              >Complete Review</CustomButton>
                            </div>
                          </div> : null : null
                  }
                </Grid> :
                // display message saying No Contracts found, Please contact administrator if contractacts are not showing.
                <Grid item xs={12} sm={6} md={6} lg={6} xl={2} order={{ xs: 3 }}> 
                  <Typography variant='body1' color='textSecondary'>No Statistics found for this flight. Please contact administrator if statistics are not showing.</Typography>
                </Grid> 
            }
          </Grid> : null
        }
      </Grid>
      <Popover
        open={props.popup === 'confirm'}
        anchorEl={props.anchorEl}
        onClose={props.closePopup}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      ><div className={styles.p3}>
          <Typography variant='caption' >Are you sure you want to save Statistics?</Typography>
          <Stack className={styles.pt3} spacing={1} direction='row'>
            <CustomButton variant='contained' size='small' onClick={props.handleStatisticPost}> <Typography variant='caption' lineHeight='normal' fontWeight='bold'>Yes</Typography></CustomButton>
            <CustomButton variant='outlined' size='small' onClick={props.closePopup}> <Typography variant='caption' lineHeight='normal'>No</Typography></CustomButton>
          </Stack>
        </div>
      </Popover>
      <>
        {props.popup === 'finalize' && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 2,
            }}
            onClick={props.closePopup}
          />
        )}
        <Popover
          open={props.popup === 'finalize'}
          onClose={props.closePopup}
          anchorReference='anchorPosition'
          anchorPosition={{
            top: window.innerHeight / 2,
            left: window.innerWidth / 2,
          }}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          style={{ zIndex: 4 }}
        ><div className={styles.p4}>
            <Typography variant='h6' pb={1}>Confirm Action</Typography>
            <Divider direction='horizontal' className={`${styles.w100}`} />
            <Typography variant='body2' pt={3}>Flight report data will now be processed for billing and invoicing.</Typography>
            <Stack pt={'2rem'} spacing={1} direction='row' justifyContent={'space-between'}>
              <CustomButton variant='contained' size='small' onClick={() => { props.closePopup(); props.handleChange('Finalized'); }} > <Typography variant='body2' lineHeight='normal' fontWeight='bold'>Okay</Typography></CustomButton>
              <CustomButton variant='outlined' size='small' onClick={props.closePopup}> <Typography variant='body2' lineHeight='normal'>Cancel</Typography></CustomButton>
            </Stack>
          </div>
        </Popover>
      </>
      <AddReportDocModal
        modal={props.modal}
        fields={props.fields}
        onChange={props.onChange}
        onSubmit={props.onSubmit}
        handleOpen={props.handleOpen}
        errors={props.errors}
        handleClose={props.onClose}
      />

      <AddNotes
        // handleOpen={props.handleOpen}
        handleOpen={props.openPopup}
        closePopup={props.closePopup}
        anchorEl={props.anchorEl}
        popup={props.popup}
        note={props.note}
        handleStats={props.handleStats}
        statRowData={props.statRowData}
        cont_item={props.cont_item}
        flightData={props.flightData}
        handleNoteBlur={props.handleNoteBlur}
        handleNotes={props.handleNotes}
        contractList={props.contractList}
        handleReadMore={props.handleReadMore}
        showMoreNote={props.showMoreNote}
      />

      <StatusModal
        statusModal={props.statusModal}
        handleStatusOpen={props.handleStatusOpen}
        statusMessage={props.statusMessage}
        onClose={props.handleStatusClose}
      />

      <ReviewModal
        anchorEl={props.anchorEl2}
        handleReview={props.handleReview}
        submitFunc={props.updateFlightReport}
        remark={props.remark}
        setRemark={props.setRemark}
        selectedOption={props.selectedOption}
        selectOption={props.selectOption}
        modalflight={props.filteredReportLogs}
        handleClose={props.handleClose}
      />
      <ReOpenModal
        anchorEl={props.anchorEl3}
        handleReview={props.handleReview}
        submitFunc={() => props.handleChange('Reopen')}
        remark={props.remark}
        setRemark={props.setRemark}
        modalflight={props.filteredReportLogs}
        handleClose={props.handleClose}
      />

      <DocViewer 
        modal={props.modal}
        item={props.attachmentDetails}
        onClose={props.onClose}
        zoomIn={props.zoomIn}
        zoomOut={props.zoomOut}
        scale={props.scale}
      />
    </>
  );
};

export default FlightReport;